if (!customElements.get('course-final-purchase')) customElements.define('course-final-purchase', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const main = document.querySelector('.ci-course-product');
    const form = main?.querySelector('form[data-type="add-to-cart-form"]');
    const nativeButton = form?.querySelector('[name="add"]');
    const link = this.querySelector('[data-final-buy]');
    if (!form || !nativeButton || !link) return;
    const button = document.createElement('button');
    button.type = 'button'; button.className = link.className; button.textContent = link.textContent; link.replaceWith(button);
    const sync = () => {
      const price = main.querySelector('.ci-course-price');
      if (price) this.querySelector('[data-final-price]').innerHTML = price.innerHTML;
      button.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      button.textContent = nativeButton.querySelector('span')?.textContent.trim() || link.textContent;
      const error = main.querySelector('.product-form__error-message');
      const target = this.querySelector('[data-final-error]');
      target.textContent = error?.textContent || ''; target.hidden = !target.textContent.trim();
    };
    button.addEventListener('click', () => { if (!button.disabled) form.requestSubmit(nativeButton); }, {signal:this.abort.signal});
    this.observer = new MutationObserver(sync);
    this.observer.observe(main, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden']});
    sync();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); }
});
if (!customElements.get('course-student-reviews')) customElements.define('course-student-reviews', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController(); const signal=this.abort.signal;
    this.querySelectorAll('[popovertarget]').forEach(button => {
      const preview=document.getElementById(button.getAttribute('popovertarget'));
      const position=()=>{ if(!preview.matches(':popover-open')) return; const r=button.getBoundingClientRect(); preview.style.left=Math.max(16,Math.min(r.left,innerWidth-preview.offsetWidth-16))+'px'; preview.style.top=Math.max(16,Math.min(r.bottom+8,innerHeight-preview.offsetHeight-16))+'px'; };
      preview.addEventListener('toggle',event=>{button.setAttribute('aria-expanded',String(event.newState==='open'));position();},{signal});
      preview.querySelector('img')?.addEventListener('load',position,{signal});
      window.addEventListener('resize',position,{signal}); document.addEventListener('scroll',position,{signal,capture:true,passive:true});
    });
  }
  disconnectedCallback(){this.abort?.abort();}
});
